import React from 'react';

/**
 * SafeText — renders plain text with two lightweight formatting rules
 * (**bold** and `code`) as real React nodes, NOT dangerouslySetInnerHTML.
 * Immune to XSS because it never touches innerHTML. Use this instead of
 * dangerouslySetInnerHTML anywhere content passes through a markdown-like
 * transform.
 */
export const SafeText = ({ text, className }) => {
  if (!text) return null;

  // Tokenize by ** ... **  and ` ... ` ; then map each token to a
  // React element or string. Preserves order and unmatched runs.
  const parts = [];
  const pattern = /(\*\*[^*]+\*\*|`[^`]+`)/g;
  let last = 0;
  let match;
  while ((match = pattern.exec(text)) !== null) {
    if (match.index > last) parts.push(text.slice(last, match.index));
    const token = match[0];
    if (token.startsWith('**')) {
      parts.push({ type: 'strong', value: token.slice(2, -2) });
    } else if (token.startsWith('`')) {
      parts.push({ type: 'code', value: token.slice(1, -1) });
    }
    last = pattern.lastIndex;
  }
  if (last < text.length) parts.push(text.slice(last));

  return (
    <p className={className}>
      {parts.map((p, i) => {
        if (typeof p === 'string') return <React.Fragment key={i}>{p}</React.Fragment>;
        if (p.type === 'strong') return <strong key={i}>{p.value}</strong>;
        if (p.type === 'code') {
          return (
            <code key={i} className="px-1 bg-slate-100 rounded font-mono text-xs">
              {p.value}
            </code>
          );
        }
        return null;
      })}
    </p>
  );
};
